export const appPageTransition = {"name":"fade","mode":"out-in","duration":0.2}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"ArtNight ist DAS kreative Erlebnis! Erlebe unterhaltsame Workshops unter der Leitung unserer ArtNight Künstler."},{"name":"p:domain_verify","content":"164500c0110929e6c2b81d64ff487571"}],"link":[{"rel":"preconnect","href":"//www.facebook.com"},{"rel":"preconnect","href":"//www.google-analytics.com"},{"rel":"preconnect","href":"//www.googletagmanager.com"},{"rel":"preconnect","href":"//script.hotjar.com"},{"rel":"preconnect","href":"//static.hotjar.com"},{"rel":"preconnect","href":"//ct.pinterest.com"},{"rel":"preconnect","href":"//a.storyblok.com"},{"rel":"preconnect","href":"//app.storyblok.com"},{"rel":"preconnect","href":"//analytics.tiktok.com"},{"rel":"preload","href":"/logo.svg","as":"image"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false